import {
  IndexTableProps,
  selectUser,
  IndexTable,
} from '@centerpiece/components';
import { Paper, Box, Button } from '@mui/material';
import { useItemContext } from 'contexts/item.context';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { usePatchMessageContactMutation } from 'store/api';
import { MessageContact } from 'store/api/models';

export const AvailabilityTable = ({
  title,
  heading,
  onRowClick,
  rows,
  headCells,
  onConfirmation = () => {},
  setAppointment = () => {},
  checkboxes = true,
}: {
  heading?: any;
  onConfirmation?: Function;
  setAppointment?: Function;
  checkboxes?: boolean;
} & IndexTableProps) => {
  const { refetchItem, afterSave, item, patchItem } = useItemContext();
  const [selected, setSelected] = useState<readonly number[]>(
    item?.appointments?.length
      ? item.appointments?.map(a => a.form?.selected)
      : []
  );
  const disabled =
    item?.appointments?.length &&
    item.appointments?.map(a => a.form?.selected)?.length > 0;
  const user = useSelector(selectUser);
  const [patchMessageContact] = usePatchMessageContactMutation();
  useEffect(() => {
    if (item?.appointments?.length) {
      setSelected(prev => [
        ...prev,
        ...(item.appointments?.map(a => a.form?.selected) || []),
      ]);
    }
  }, item?.appointments);
  return (
    <Paper elevation={3} sx={{ p: 2, mb: 5 }}>
      {heading}
      <IndexTable
        title={title}
        // defaultOrder={'desc'}
        // defaultOrderBy={'due'}
        onRowClick={onRowClick}
        checkboxes={checkboxes}
        headCells={headCells}
        rows={
          disabled
            ? rows.map(r => ({ ...r, disabled: !r.form?.selected }))
            : rows
        }
        selected={selected}
        setSelected={setSelected}
        selectMultiple={false}
        // iconHead={<div />}
        pagination={false}
      />
      {checkboxes && (
        <Box sx={{ textAlign: 'center', mt: 2 }}>
          {item?.appointments?.length ? (
            <Button
              sx={{ textAlign: 'center', px: 3, py: 1 }}
              color={'secondary'}
              variant="contained"
              onClick={() => setAppointment(item?.appointments?.[0])}
            >
              View Event Notice
            </Button>
          ) : (
            <Button
              variant="contained"
              color={'secondary'}
              sx={{ textAlign: 'center', px: 3, py: 1 }}
              disabled={!!!selected?.length}
              onClick={async () => {
                let newMsgs: number[] = [];
                rows.forEach(row => {
                  const mc_id = row.msg?.contacts?.find(
                    (mc: any) => mc.id === user.contact && mc.status === 'New'
                  )?.mc_id;
                  if (mc_id) newMsgs.push(mc_id);
                });
                await Promise.all(
                  newMsgs.map(newMsg =>
                    patchMessageContact({
                      id: newMsg,
                      status: 'Read',
                    } as MessageContact)
                  )
                );
                refetchItem();

                await afterSave();
                onConfirmation(rows.find(r => r.id === selected[0]));
              }}
            >
              Confirm Selection
            </Button>
          )}
          {/* <FormControlLabel
          sx={{ ml: 2 }}
          value="rejection"
          control={<Checkbox />}
          label="Send rejection"
          labelPlacement="end"
        /> */}
        </Box>
      )}
    </Paper>
  );
};
